// eslint-disable-next-line simple-import-sort/imports
import './instrumentation'
import * as Sentry from '@sentry/react'

import { StrictMode } from 'react'
import ReactDOM from 'react-dom/client'
import ReactGA from 'react-ga4'
import { routeTree } from './routeTree.gen'

import './index.css'
import { createRouter, RouterProvider } from '@tanstack/react-router'

import { persistLastVisitedRouteIfEligible } from '~/utils/last-visited-route'

const router = createRouter({ routeTree })

router.subscribe('onResolved', event => {
  persistLastVisitedRouteIfEligible(event.toLocation)
})

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}

const googleAnalyticsMeasureId = import.meta.env.VITE_GOOGLE_ANALYTICS_MEASURE_ID
if (googleAnalyticsMeasureId) ReactGA.initialize(import.meta.env.VITE_GOOGLE_ANALYTICS_MEASURE_ID)

ReactDOM.createRoot(document.getElementById('root')!, {
  // Callback called when an error is thrown and not caught by an ErrorBoundary.
  onUncaughtError: Sentry.reactErrorHandler((error, errorInfo) => {
    console.warn({ message: 'Uncaught error', error, componentStack: errorInfo.componentStack })
  }),
  // Callback called when React catches an error in an ErrorBoundary.
  onCaughtError: Sentry.reactErrorHandler(),
  // Callback called when React automatically recovers from errors.
  onRecoverableError: Sentry.reactErrorHandler(),
}).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>,
)
